export class IFilters {
  id: string[];

  name: string;

  status: any[];

  identity: any[];

  integration: any[];

  productId: any[];

  category: any[];

  feedback: any[];

  startDate: Date | null;

  endDate: Date | null;

  metrics: any[];

  completed: boolean;

  quality: any[];

  issues: {
    min: number | undefined;
    max: number | undefined;
  };

  values: {
    min: number | undefined;
    max: number | undefined;
  };

  constructor({
    id,
    name,
    status,
    identity,
    integration,
    productId,
    category,
    feedback,
    startDate,
    endDate,
    metrics,
    completed,
    quality,
    issues,
    values,
  }: {
    id?: string[];
    name?: string;
    status?: any[];
    identity?: any[];
    integration?: any[];
    productId?: any[];
    category?: any[];
    feedback?: any[];
    startDate?: Date | null;
    endDate?: Date | null;
    metrics?: any[];
    completed?: boolean;
    quality?: any[];
    issues?: any;
    values?: any;
  }) {
    this.id = id || [];
    this.name = name || '';
    this.status = status || [];
    this.identity = identity || [];
    this.integration = integration || [];
    this.productId = productId || [];
    this.category = category || [];
    this.feedback = feedback || [];
    this.startDate = startDate ? new Date(startDate) : null;
    this.endDate = endDate ? new Date(endDate) : null;
    this.metrics = metrics || [];
    this.completed = completed || false;
    this.quality = quality || [];
    this.issues = issues || { min: undefined, max: undefined };
    this.values = values || { min: undefined, max: undefined };
  }
}
